import useGlobalStore from '@/store/useGlobalStore'
import type { CartItemType } from '@/store/types/cart'
import type { HydraGetSkuAvailabilityResponse } from '@/lib/services/Hydra/order/getSkuAvailability'
import { ConfirmAddToActiveSubscription } from './ConfirmAddToActiveSubscription'
import { SelectActiveSubscription } from './SelectActiveSubscription'

type Props = {
  itemToAddToSubscription: CartItemType
  isLoadingProductAvailability: boolean
  productAvailability: HydraGetSkuAvailabilityResponse | null
}

export const AddProductToSubscription = ({
  itemToAddToSubscription,
  isLoadingProductAvailability,
  productAvailability,
}: Props) => {
  const {
    app: {
      addProductToSubscription: {
        isConfirmAddToActiveSubscriptionModalOpen,
        isSelectActiveSubscriptionModalOpen,
      },
    },
  } = useGlobalStore()

  return (
    <div>
      {isSelectActiveSubscriptionModalOpen && (
        <SelectActiveSubscription
          isLoadingProductAvailability={isLoadingProductAvailability}
          productAvailability={productAvailability}
          itemToAddToSubscription={itemToAddToSubscription}
        />
      )}
      {isConfirmAddToActiveSubscriptionModalOpen && (
        <ConfirmAddToActiveSubscription
          itemToAddToSubscription={itemToAddToSubscription}
        />
      )}
    </div>
  )
}
